import React, { Component } from 'react';
import { connect } from "react-redux";

class FormCompanyAdd extends Component {
  componentDidMount() {
    this.props.showSearch();
  }
  render() {
    return (
      <div class="row show-grid">
        <div class="col-md-6">
          <form>
            <div class="form-group">
              <label for="">Company name</label>
              <input type="text" class="form-control" id="InputCompanyName" aria-describedby="" placeholder="Example, Inc."/>
            </div>
            <div class="form-group">
              <label for="">Company description</label>
              <textarea class="form-control" id="InputCompanyDescription" rows="2" placeholder="Short descriptive text about the company."></textarea>
            </div>
            <div class="form-group">
              <label for="">Company website</label>
              <input type="text" class="form-control" id="InputCompanyWebsite" aria-describedby="" placeholder="https://example.com"/>
            </div>
            <div class="form-group">
              <label for="">Company Jobs</label>
              <input type="text" class="form-control" id="InputCompanyJobs" aria-describedby="" placeholder="https://example.com/jobs"/>
            </div>
            <button type="submit" class="btn btn-primary">Submit</button>
          </form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  showSearch: () => dispatch({
      type: "SHOW_SEARCH",
      showSearch: false
  })
})

export default connect(null, mapDispatchToProps)(FormCompanyAdd);
